import { render, staticRenderFns } from "./MerchantWithdraw.vue?vue&type=template&id=65a9eeb3&scoped=true&"
import script from "./MerchantWithdraw.vue?vue&type=script&lang=js&"
export * from "./MerchantWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./MerchantWithdraw.vue?vue&type=style&index=0&id=65a9eeb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9eeb3",
  null
  
)

export default component.exports